<template>
  <div>
    <!-- nav -->
    <headernav></headernav>
    <!-- banner -->
    <div class="banner">
      <!-- 表单 -->
      <!-- <el-form :model="ruleForm" ref="ruleForm" :rules="rules" class="form SignIn paslogin"  v-show="coverIsOn">
        <h2>密码登录</h2>
        <el-form-item prop="tel" label="手机号"  class="tit-tel">
          <el-input placeholder="请输入手机号" v-model="ruleForm.tel" @keyup.enter.native="submitForm('ruleForm')"></el-input>
        </el-form-item>
        <img src="../../assets/img/Rectangle Copy 2.png" alt="">
        <el-form-item prop="password" label="密码"  class="tit-pas">
          <el-input placeholder="请输入密码" v-model="ruleForm.password" show-password @keyup.enter.native="submitForm('ruleForm')"></el-input>
        </el-form-item>
        <img src="../../assets/img/Rectangle Copy 2.png" alt="">
        <a class="qiehuan" @click="numLogin">忘记密码</a>
        <a class="qiehuan" @click="numLogin">验证码登录</a>
        <el-button type="primary" @click="paslogin">登录</el-button>
      </el-form> -->
      <!-- 验证码登录 -->
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        :rules="rules"
        class="form SignIn paslogin"
        v-show="coverIsOn"
      >
        <h2>验证码登录</h2>
        <el-form-item prop="tel" label="手机号" class="tit-tel">
          <el-input
            placeholder="请输入手机号"
            v-model="ruleForm.tel"
            @keyup.enter.native="submitForm('ruleForm')"
          ></el-input>
        </el-form-item>
        <img src="../../assets/img/Rectangle Copy 2.png" alt="" />
        <el-form-item prop="resetverification" label="验证码" class="tit-ver">
          <el-input
            placeholder="请输入验证码"
            v-model="ruleForm.resetverification"
            @keyup.enter.native="submitForm('ruleForm')"
          ></el-input>
          <div class="getsmscode" v-if="codecheck">{{ codetime }}秒后获取</div>
          <div class="getsmscode" @click="getver" v-else>获取验证码</div>
        </el-form-item>
        <img src="../../assets/img/Rectangle Copy 2.png" alt="" />
        <el-button type="primary" @click="paslogin">登录</el-button>
      </el-form>
      <!-- 忘记密码 -->
      <!-- <el-form :model="ruleForm" ref="ruleForm" :rules="rules" class="form SignIn paslogin"  v-show="coverIsOpen">
        <h2>重置密码</h2>
        <el-form-item prop="resettel" label="手机号"  class="tit-tel">
          <el-input placeholder="请输入手机号" v-model="ruleForm.resettel" @keyup.enter.native="submitForm('ruleForm')"></el-input>
        </el-form-item>
        <img src="../../assets/img/Rectangle Copy 2.png" alt="">
        <el-form-item prop="resetverification" label="验证码"  class="tit-ver">
          <el-input placeholder="请输入验证码" v-model="ruleForm.resetverification" @keyup.enter.native="submitForm('ruleForm')"></el-input>
          <div class="getsmscode" v-if="codecheck">{{ codetime }}秒后获取</div>
          <div class="getsmscode" @click="getver" v-else>获取验证码</div>
        </el-form-item>
        <img src="../../assets/img/Rectangle Copy 2.png" alt="">
        <el-form-item prop="resetpassword" label="登录密码"  class="tit-pas">
          <el-input placeholder="请输入登录密码" v-model="ruleForm.resetpassword" show-password  @keyup.enter.native="submitForm('ruleForm')"></el-input>
        </el-form-item>
        <img src="../../assets/img/Rectangle Copy 2.png" alt="">
        <el-form-item prop="resetpasswordsure" label="确认密码"  class="tit-pas-sure">
          <el-input placeholder="请重复输入登录密码" v-model="ruleForm.resetpasswordsure" show-password  @keyup.enter.native="submitForm('ruleForm')"></el-input>
        </el-form-item>
        <el-button type="primary" @click="pasloginsure">确认修改</el-button>
        <img src="../../assets/img/Rectangle Copy 2.png" alt="">
      </el-form> -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import crypto from "crypto";
import headernav from "../../components/common/headernav";
export default {
  name: "yhdl",
  components: {
    headernav,
  },
  data() {
    return {
      coverIsOpen: false,
      coverIsOn: true,
      codecheck: false,
      codetime: 60,
      ruleForm: {
        tel: "", //手机号
        password: "", //密码
        resettel: "", //重置手机号
        resetverification: "", //重置验证码
        resetpassword: "", //重置密码
        resetpasswordsure: "", //重置密码确定
      },
      rules: {
        tel: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        resettel: [
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
        resetverification: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        resetpassword: [
          { required: true, message: "请输入登录密码", trigger: "blur" },
        ],
        resetpasswordsure: [
          { required: true, message: "请重复输入登录密码", trigger: "blur" },
        ],
      },
      url: "",
    };
  },
  mounted() {
    this.url=this.global.baseUrl
  },
  methods: {
    // <!--进入手机号码登录页-->
    numLogin() {
      this.coverIsOn = false;
      this.coverIsOpen = true;
    },
    telLogin() {
      this.coverIsOn = true;
      this.coverIsOpen = false;
    },
    // 登录页面
    paslogin() {
      if (this.ruleForm.tel == "") {
        this.$message.info("请输入手机号");
      } else if (!/^1\d{10}$/.test(this.ruleForm.tel)) {
        this.$message.info("手机号码格式不正确");
      } else if (this.ruleForm.resetverification == "") {
        this.$message.info("请输入验证码");
      } else {
        axios
          .post(
            `${this.url}/news/regUserLogin?mobile=${this.ruleForm.tel}&code=${this.ruleForm.resetverification}`,
            {}
          )
          .then((response) => {
            if (response.data.code === 1) {
              if (response.data.data.cpType == 3) {
                // 执行 企业后台系统跳转
                // window.location.href = `http://120.55.169.187:34362/#/login?userName=${response.data.data.userName}&password=${response.data.data.userPassword}`
                window.location.href = `http://enterprise.freshpower.com.cn/#/login?userName=${response.data.data.userName}&password=${response.data.data.userPassword}`;
              } else if (response.data.data.cpType == 2) {
                // 执行 运营后台系统跳转
                // window.location.href = `http://120.55.169.187:34361/#/login?userName=${response.data.data.userName}&password=${response.data.data.userPassword}`
                window.location.href = `http://agent.freshpower.com.cn/#/login?userName=${response.data.data.userName}&password=${response.data.data.userPassword}`;
              }
            } else {
              this.$message.error(response.data.msg);
            }
          })
          .catch((err) => {
            this.$message.error(response.data.msg);
          });
      }
    },
    // 密码重置
    pasloginsure() {
      if (
        this.ruleForm.resettel != "" &&
        this.ruleForm.resetverification != "" &&
        this.ruleForm.resetpassword != "" &&
        this.ruleForm.resetpasswordsure != ""
      ) {
        if (this.ruleForm.resetpassword === this.ruleForm.resetpasswordsure) {
          axios
            .post(
              `${this.url}/news/modifyPassword?mobile=${this.ruleForm.resettel}&validCode=${this.ruleForm.resetverification}&userPassword=${this.ruleForm.resetpassword}`,
              {}
            )
            .then((response) => {
              if (response.data.code === 1) {
                this.$message.success(response.data.msg);
              } else {
                this.$message.error(response.data.msg);
              }
            })
            .catch((err) => {
              this.$message.error(response.data.msg);
            });
        } else {
          this.$message.error("两次密码不匹配");
        }
      } else {
        this.$message.error("登录失败");
      }
    },
    // 发送短信验证码
    getver() {
      if (this.ruleForm.tel == "") {
        this.$message.info("请输入手机号");
      } else if (!/^1\d{10}$/.test(this.ruleForm.tel)) {
        this.$message.info("手机号码格式不正确");
      } else {
        axios
          .post(
            `${this.url}/news/sendValidCode?mobile=${this.ruleForm.tel}`,
            {}
          )
          .then((response) => {
            if (response.data.code === 1) {
              this.$message.success("短信验证码发送成功");
              this.onTime();
            } else {
              this.$message.error(response.data.msg);
            }
          })
          .catch((err) => {
            this.$message.error(response.data.msg);
          });
      }
    },
    // 短信验证码60秒倒计时
    onTime() {
      var codetimes = 60;
      this.codecheck = true;
      this.codetime = 60;
      var setint = setInterval(() => {
        codetimes = --codetimes;
        this.codetime = codetimes;
        if (codetimes == 0) {
          this.codecheck = false;
          codetimes = 60;
          this.codetime = 60;
        }
      }, 1000);
      setint;
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/dlzc.css";
</style>



// WEBPACK FOOTER //
// src/pages/yhdl/yhdl.vue